import { appBarClasses as muiAppBarClasses } from '@mui/material/AppBar';

// eslint-disable-next-line deprecation/deprecation
export { default as AppBar, type AppBarProps } from './AppBar';

/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const appBarClasses = muiAppBarClasses;
